import UserInfo from "components/UserInfo";
import styles from "./HeaderItem.module.scss";

const HeaderItem = ({ photos, info, index, data }) => {
  return (
    <div className={styles.header}>
      <div className={styles.user}>
        <UserInfo
          src={photos[Object.keys(info)[index]]}
          name={`${data?.first_name} ${data?.last_name}`}
        />
      </div>
      <div className={styles.details}>
        <span className={styles.label}>Total real calls: </span>
        {data?.total_real_calls_computed ?? data?.total_real_calls}
        <span className={styles.label}>Total call duration: </span>
        {data?.total_calls_duration_computed ?? data?.total_calls_duration}
        <span className={styles.label}>Outgoing emails: </span>
        {data?.total_emails_computed ?? data?.total_emails}
      </div>
    </div>
  );
};

export default HeaderItem;
